import { useState } from "react";
import { TbExternalLink } from "react-icons/tb";
import Modal from "../../../../components/modals/Modal";
import { doc, updateDoc } from "firebase/firestore";
import { firestore } from "../../../../firebase/config";
import { useTournamentUpdate } from "../../TournamentContext";

const Hyperlink = ({ bracket, games, teams, tournamentId }) => {
  const { updateGames } = useTournamentUpdate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [firebaseUpdates, setFirebaseUpdates] = useState({});

  const handleFirebaseUpdates = (gameId, value) => {
    setFirebaseUpdates((prevUpdates) => ({
      ...prevUpdates,
      [`${gameId}.hyperlink`]: value,
    }));

    updateGames(gameId, { ...games[gameId], hyperlink: value });
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const writeHyperlink = async () => {
    const bracketRef = doc(firestore, "brackets", tournamentId);

    try {
      await updateDoc(bracketRef, firebaseUpdates);

      toggleModal();
    } catch (error) {
      alert("Something went wrong!", error.message);
      console.log(error);
    }
  };

  return (
    <>
      <TbExternalLink
        className="w-10 h-10 border-2 border-black p-1 cursor-pointer rounded"
        onClick={() => toggleModal()}
      />

      <Modal
        isOpen={isModalOpen}
        title="Hyperlinks"
        subtitle="Link a game to external media"
        onCancel={toggleModal}
        onConfirm={writeHyperlink}
      >
        <p className="ml-1 mb-2 text-stone-600 text-sm">
          Make sure to include {`https://www.`} at the start
        </p>
        {Object.entries(bracket).map(([bracketLevel, bracket]) => {
          return (
            <div key={bracketLevel}>
              <div className="text-xl font-bold">{bracketLevel}</div>

              {Object.entries(bracket).map(([roundId, gameIds]) => (
                <div key={`${bracketLevel}-${roundId}`}>
                  <div className="text-xl font-semi-bold">
                    Round {Number(roundId) + 1}
                  </div>
                  <div>
                    {gameIds.map((gameId) => {
                      const game = games[gameId];
                      const { team1Id, team2Id } = game;
                      if (
                        team1Id === "BYE" ||
                        team2Id === "BYE" ||
                        team1Id === "TBD" ||
                        team2Id === "TBD" ||
                        team1Id === "Hayes Lower Winner" ||
                        team2Id === "Hayes Lower Winner" ||
                        team1Id === "Hayes Upper Winner" ||
                        team2Id === "Hayes Upper Winner"
                      ) {
                        return null;
                      }

                      return (
                        <div key={gameId} className="mt-1.5">
                          <div className="flex gap-1 text-xs text-stone-600 font-semibold">
                            <div>{teams[game.team1Id].name}</div>
                            <p>v</p>
                            <div>{teams[game.team2Id].name}</div>
                          </div>
                          <input
                            className="border"
                            onChange={(event) =>
                              handleFirebaseUpdates(gameId, event.target.value)
                            }
                            placeholder={game.hyperlink ?? "No link"}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              ))}
            </div>
          );
        })}
      </Modal>
    </>
  );
};

export default Hyperlink;
